import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { esES } from '@mui/x-data-grid/locales';
import { Card, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  root: { '&.header-datagrid': { backgroundColor: '#4caf50' } }
}));

export default function DataTable({
  columns, rows, setSelectedRows, selectedRows,
  nombreUsuario, activateCheckBox, onChangeStatus, loading
}) {
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 20 });
  const classes = useStyles();
  return (
    <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
      <Grid align="center" size={{ md: 12, sm: 12, xs: 12 }}>
        <Card className={classes.root}>
          <DataGrid
            localeText={esES.components.MuiDataGrid.defaultProps.localeText}
            rows={rows}
            columns={columns}
            loading={loading}
            showToolbar
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pageSizeOptions={[20, 50, 100]}
            pagination
            checkboxSelection={activateCheckBox}
            disableRowSelectionExcludeModel
            disableRowSelectionOnClick
            autoHeight
            onRowSelectionModelChange={(newSelec) => {
              setSelectedRows(Array.from(newSelec.ids));
            }}
            rowSelectionModel={{ type: 'include', ids: new Set(selectedRows) }}
            isRowSelectable={(params) => (
              nombreUsuario === undefined || params.row.nombreUsuario !== nombreUsuario
            )}
            processRowUpdate={(newRow, oldRow) => {
              const changedField = Object.keys(newRow).find((key) => newRow[key] !== oldRow[key]);
              if (changedField && onChangeStatus) {
                onChangeStatus({ id: newRow.id, field: changedField, value: newRow[changedField] });
              }
              return newRow;
            }}
          />
        </Card>
      </Grid>
    </Grid>
  );
}
DataTable.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  setSelectedRows: PropTypes.func,
  selectedRows: PropTypes.array,
  nombreUsuario: PropTypes.string,
  activateCheckBox: PropTypes.bool,
  onChangeStatus: PropTypes.func,
  loading: PropTypes.bool
};
